import { PromptType } from "../types/qas/qasPromptTypes";
import { CachingType } from "../types/qas/qasTypes";
import { AnswerFilterType, CompletenessFilterType } from "../types/qas/questionTypes";

// список использования кэша ответов
export const ANSWER_CACHE_USAGE_LIST: { type: CachingType; translation: string }[] = [
	{ type: "no", translation: "selectItem_doNotUse" },
	{ type: "all", translation: "selectItem_anyAnswers" },
	{ type: "checked", translation: "selectItem_onlyCheckedAnswers" },
];

// список полноты вопроса
export const LIST_OF_COMPLETENESS_OF_THE_QUESTION: { type: CompletenessFilterType; translation: string }[] = [
	{ type: "all", translation: "selectItem_all" },
	{ type: "complete", translation: "selectItem_complete" },
	{ type: "incomplete", translation: "selectItem_incomplete" },
];

// список типов ответа
export const LIST_OF_ANSWER_TYPES: { type: AnswerFilterType; translation: string }[] = [
	{ type: "all", translation: "selectItem_all" },
	{ type: "checked", translation: "selectItem_checked" },
	{ type: "unchecked", translation: "selectItem_unchecked" },
	{ type: "empty", translation: "selectItem_empty" },
];

// список типов промпта
export const LIST_OF_PROMPT_TYPES: { type: PromptType; translation: string }[] = [
	{ type: "chat", translation: "selectItem_chat" },
	{ type: "ask", translation: "selectItem_documentRequest" },
	{ type: "cleandoc", translation: "selectItem_documentCleaning" },
	{ type: "similars_generator", translation: "selectItem_synonymPhraseGenerator" },
	{ type: "paraphrase", translation: "selectItem_paraphrasingFragmentOfText" },
	{ type: "summarize", translation: "selectItem_textSummarization" },
	{ type: "question_generator", translation: "selectItem_textQuestionGenerator" },
	{ type: "replace", translation: "selectItem_vectorInfoReplacement" },
	{ type: "mismatch", translation: "selectItem_searchForInfoInconsistencies" },
	{ type: "anchors", translation: "selectItem_generatingAnchorsForDocuments" },
	{ type: "annotation", translation: "selectItem_documentAnnotation" },
];

export const extensionsAndMimeTypes = [
	[".txt", "text/plain"],
	[".csv", "text/csv"],

	[".odt", "application/vnd.oasis.opendocument.text"],
	[".ods", "application/vnd.oasis.opendocument.spreadsheet"],
	// [".odp", "application/vnd.oasis.opendocument.presentation"],

	[".doc", "application/msword"],
	[".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
	[".xls", "application/vnd.ms-excel"],
	[".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
	// [".ppt", "application/vnd.ms-powerpoint"],
	// [".pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],

	[".rtf", "application/rtf"],
	[".pdf", "application/pdf"],
	// [".dif"],
	// [".sxi", "application/vnd.sun.xml.impress"],
	// [".odb", "application/vnd.oasis.opendocument.database"],
	// [".mdb", "application/x-msaccess"],
	// [".odg", "application/vnd.oasis.opendocument.graphics"],
];
